import {useMemo} from 'react';
import {emojiList, IEmoji} from '@ui/assets/emojis';
import {PULSE_SCALE, PulseScaleOption} from '../../shared/pulse-scale';

export interface PulseEmojiOption {
  key: PulseScaleOption['key'];
  label: string;
  responseValue: PulseScaleOption['responseValue'];
  emoji: IEmoji;
}

export const usePulseEmoji = () => {
  const emojiOptions = useMemo<PulseEmojiOption[]>(
    () =>
      PULSE_SCALE.map(({key, label, responseValue}) => ({
        key,
        label,
        responseValue,
        emoji: emojiList[key],
      })),
    [],
  );

  const emojiMap = useMemo(
    () =>
      emojiOptions.reduce(
        (acc, option) => ({...acc, [option.key]: option}),
        {} as Record<PulseEmojiOption['key'], PulseEmojiOption>,
      ),
    [emojiOptions],
  );

  return {emojiOptions, emojiMap};
};
